import { ErrorBoundary } from 'react-error-boundary'
import { Toaster } from 'react-hot-toast'

import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { AppDown } from '~/components/appDown'
import { useAuthQuery } from '~/queries/auth'
import { queryClient } from '~/queryClient'
import { useSentry } from '~/utils/sentry'

import { router } from './router'

export const App: React.FC = () => {
	const { captureException } = useSentry()

	return (
		<ErrorBoundary FallbackComponent={AppDown} onError={error => captureException(error, 'error')}>
			<QueryClientProvider client={queryClient}>
				<InnerApp />
			</QueryClientProvider>
			<Toaster containerStyle={{ top: 40 }} />
		</ErrorBoundary>
	)
}

function InnerApp() {
	const { data: auth, isError, error  } = useAuthQuery()


	if (isError) throw error
	if (!auth) return null

	return <RouterProvider router={router} context={{ auth }} />
}
